import React, { useState, Fragment } from "react";
import { li, UL } from "../../../../AbstractElements";
import { Filter } from "react-feather";
import { useForm, useController } from "react-hook-form";
import { FilterButton, LevelMenu } from "../../../../Constant";
import {
  Dropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
} from "reactstrap";
import FilterForm from "./FilterForm.jsx";

const FilterTable = (props) => {
  const [levelMenu, setLevelMenu] = useState(() => false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => {
    setDropdownOpen((prevState) => !prevState);
    setLevelMenu(!levelMenu);
  };

  return (
    <Fragment>
      <Dropdown
        isOpen={dropdownOpen}
        toggle={toggle}
        className="button-level-menu outside"
      >
        <DropdownToggle className={levelMenu ? "nav-link active" : "nav-link"}>
          <Filter /> Filter
        </DropdownToggle>
        <DropdownMenu tag={"ul"} className="header-level-menu menu-to-be-close">
          <FilterForm
            toggle={toggle}
            options={props.options}
            filterData={props.filterData}
            setFilterData={props.setFilterData}
            setSearchData={props.setSearchData}
            setFilterType={props.setFilterType}
            statusData={props.statusData}
            carTypeData={props.carTypeData}
          />
        </DropdownMenu>
      </Dropdown>
    </Fragment>
  );
};

export default FilterTable;
